import React from "react";
import { useNavigate } from "react-router-dom";
import { RiChatHistoryLine } from "react-icons/ri";

const ViewHistoryBtn = () => {

    const navigate = useNavigate();

    const goToHistory = () => {
        navigate("/dashboard");
        // "navbar", "pills-history-tab"
        let dashboardtab = {
            ActiveTab: 'Alltabcategory',
            Alltabcategory: 'pills-newall-tab',
            Servicecategory: 'pills-all-services',
            Productcategory: 'pills-all-tab',
            headnavBar: 'pills-history-tab',
        };
        sessionStorage.setItem('dashboardtab', JSON.stringify(dashboardtab));
    };

    return (
        <div className="d-flex justify-content-center w-100">
            <div className="text-center">
                <span className="fs-12 ff-poppins-medium">
                    To view past bookings, click view history
                </span>

                <div className="d-flex justify-content-center mt-2">
                    <button className="viewHistoryBtn" onClick={goToHistory}>
                        <RiChatHistoryLine size={16} />
                        <span className="ms-2">View History</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ViewHistoryBtn;
